
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 22"}, attrs),
              ...rest,
            },
            children.concat([_c('polygon',{staticStyle:{"fill":"#1c0f0c"},attrs:{"points":"10.5 1.61 11.93 3.01 4.62 10.5 35.69 10.5 35.69 12.5 4.62 12.5 11.93 19.99 10.5 21.39 0.85 11.5 10.5 1.61"}})])
          )
        }
      }
    